// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/user/v1/attribute.proto" (package "c1.api.user.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { Facets } from "../../search/v1/facet";
import { Timestamp } from "../../../../google/protobuf/timestamp";
import { Any } from "../../../../google/protobuf/any";
/**
 * @generated from protobuf message c1.api.user.v1.UserAttributeManagementServiceListAttributeTypesRequest
 */
export interface UserAttributeManagementServiceListAttributeTypesRequest {
}
/**
 * @generated from protobuf message c1.api.user.v1.UserAttributeTypeConfigApp
 */
export interface UserAttributeTypeConfigApp {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
}
/**
 * @generated from protobuf message c1.api.user.v1.UserAttributeTypeConfigAppUserProfile
 */
export interface UserAttributeTypeConfigAppUserProfile {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_user_profile_attribute_key = 2;
     */
    appUserProfileAttributeKey: string;
}
/**
 * @generated from protobuf message c1.api.user.v1.UserAttributeTypeConfigCustomAppUserProfile
 */
export interface UserAttributeTypeConfigCustomAppUserProfile {
    /**
     * @generated from protobuf field: string user_profile_attribute_key = 1;
     */
    userProfileAttributeKey: string;
    /**
     * @generated from protobuf field: string app_id = 2;
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_user_profile_attribute_key = 3;
     */
    appUserProfileAttributeKey: string;
}
/**
 * @generated from protobuf message c1.api.user.v1.UserAttributeTypeConfigCelExpression
 */
export interface UserAttributeTypeConfigCelExpression {
    /**
     * @generated from protobuf field: string user_profile_attribute_key = 1;
     */
    userProfileAttributeKey: string;
    /**
     * @generated from protobuf field: string cel_expression = 2;
     */
    celExpression: string;
}
/**
 * @generated from protobuf message c1.api.user.v1.UserAttributeType
 */
export interface UserAttributeType {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string display_name = 2;
     */
    displayName: string;
    /**
     * @generated from protobuf oneof: config
     */
    config: {
        oneofKind: "app";
        /**
         * @generated from protobuf field: c1.api.user.v1.UserAttributeTypeConfigApp app = 100;
         */
        app: UserAttributeTypeConfigApp;
    } | {
        oneofKind: "appUserProfile";
        /**
         * @generated from protobuf field: c1.api.user.v1.UserAttributeTypeConfigAppUserProfile app_user_profile = 101;
         */
        appUserProfile: UserAttributeTypeConfigAppUserProfile;
    } | {
        oneofKind: "customAppUserProfile";
        /**
         * @generated from protobuf field: c1.api.user.v1.UserAttributeTypeConfigCustomAppUserProfile custom_app_user_profile = 102;
         */
        customAppUserProfile: UserAttributeTypeConfigCustomAppUserProfile;
    } | {
        oneofKind: "celExpression";
        /**
         * @generated from protobuf field: c1.api.user.v1.UserAttributeTypeConfigCelExpression cel_expression = 103;
         */
        celExpression: UserAttributeTypeConfigCelExpression;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.user.v1.UserAttributeMappingFallback
 */
export interface UserAttributeMappingFallback {
    /**
     * @generated from protobuf oneof: fallback
     */
    fallback: {
        oneofKind: "app";
        /**
         * @generated from protobuf field: c1.api.user.v1.UserAttributeTypeConfigApp app = 100;
         */
        app: UserAttributeTypeConfigApp;
    } | {
        oneofKind: "appUserProfile";
        /**
         * @generated from protobuf field: c1.api.user.v1.UserAttributeTypeConfigAppUserProfile app_user_profile = 101;
         */
        appUserProfile: UserAttributeTypeConfigAppUserProfile;
    } | {
        oneofKind: "celExpression";
        /**
         * @generated from protobuf field: c1.api.user.v1.UserAttributeTypeConfigCelExpression cel_expression = 102;
         */
        celExpression: UserAttributeTypeConfigCelExpression;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.user.v1.UserAttributeManagementServiceListAttributeTypesResponse
 */
export interface UserAttributeManagementServiceListAttributeTypesResponse {
    /**
     * @generated from protobuf field: repeated c1.api.user.v1.UserAttributeType list = 1;
     */
    list: UserAttributeType[];
}
/**
 * @generated from protobuf message c1.api.user.v1.UserAttributeManagementServiceListRequest
 */
export interface UserAttributeManagementServiceListRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.user.v1.UserAttributeMapConfigExpandMask expand_mask = 3;
     */
    expandMask?: UserAttributeMapConfigExpandMask;
}
/**
 * @generated from protobuf message c1.api.user.v1.UserAttributeManagementServiceListResponse
 */
export interface UserAttributeManagementServiceListResponse {
    /**
     * @generated from protobuf field: repeated c1.api.user.v1.UserAttributeMappingView list = 1;
     */
    list: UserAttributeMappingView[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3;
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.user.v1.UserAttributeMapping
 */
export interface UserAttributeMapping {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string app_id = 2;
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_user_profile_attribute_key = 3;
     */
    appUserProfileAttributeKey: string;
    /**
     * @generated from protobuf field: string display_name = 4;
     */
    displayName: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 5;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 6;
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: int32 count = 7;
     */
    count: number;
    /**
     * @generated from protobuf field: c1.api.user.v1.UserAttributeType attribute_type = 8;
     */
    attributeType?: UserAttributeType;
    /**
     * @generated from protobuf field: uint32 priority = 9;
     */
    priority: number;
    /**
     * @generated from protobuf field: repeated c1.api.user.v1.UserAttributeMappingFallback fallbacks = 10;
     */
    fallbacks: UserAttributeMappingFallback[];
    /**
     * @generated from protobuf field: int32 evaluation_error_count = 11;
     */
    evaluationErrorCount: number;
}
/**
 * @generated from protobuf message c1.api.user.v1.UserAttributeMappingView
 */
export interface UserAttributeMappingView {
    /**
     * @generated from protobuf field: c1.api.user.v1.UserAttributeMapping user_attribute_mapping = 1;
     */
    userAttributeMapping?: UserAttributeMapping;
    /**
     * @generated from protobuf field: string app_path = 2;
     */
    appPath: string;
    /**
     * @generated from protobuf field: string fallbacks_path = 3;
     */
    fallbacksPath: string;
}
/**
 * @generated from protobuf message c1.api.user.v1.UserAttributeMappingRef
 */
export interface UserAttributeMappingRef {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.user.v1.UserAttributeMappingErrorLog
 */
export interface UserAttributeMappingErrorLog {
    /**
     * @generated from protobuf field: string user_attribute_mapping_id = 1;
     */
    userAttributeMappingId: string;
    /**
     * @generated from protobuf field: string user_id = 2;
     */
    userId: string;
    /**
     * @generated from protobuf field: string error = 3;
     */
    error: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 4;
     */
    updatedAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.user.v1.UserAttributeManagementServiceGetRequest
 */
export interface UserAttributeManagementServiceGetRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: c1.api.user.v1.UserAttributeMapConfigExpandMask expand_mask = 2;
     */
    expandMask?: UserAttributeMapConfigExpandMask;
}
/**
 * @generated from protobuf message c1.api.user.v1.UserAttributeManagementServiceGetResponse
 */
export interface UserAttributeManagementServiceGetResponse {
    /**
     * @generated from protobuf field: c1.api.user.v1.UserAttributeMappingView attribute = 1;
     */
    attribute?: UserAttributeMappingView;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.user.v1.UserAttributeMapConfigExpandMask
 */
export interface UserAttributeMapConfigExpandMask {
    /**
     * @generated from protobuf field: repeated string paths = 1;
     */
    paths: string[];
}
/**
 * @generated from protobuf message c1.api.user.v1.UserAttributeManagementServiceCreateRequest
 */
export interface UserAttributeManagementServiceCreateRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_user_profile_attribute_key = 2;
     */
    appUserProfileAttributeKey: string;
    /**
     * @generated from protobuf field: string display_name = 3;
     */
    displayName: string;
    /**
     * @generated from protobuf field: c1.api.user.v1.UserAttributeType attribute_type = 5;
     */
    attributeType?: UserAttributeType;
    /**
     * @generated from protobuf field: c1.api.user.v1.UserAttributeMapConfigExpandMask expand_mask = 4;
     */
    expandMask?: UserAttributeMapConfigExpandMask;
    /**
     * @generated from protobuf field: repeated c1.api.user.v1.UserAttributeMappingFallback fallbacks = 6;
     */
    fallbacks: UserAttributeMappingFallback[];
    /**
     * @generated from protobuf field: repeated string profile_type_ids = 7;
     */
    profileTypeIds: string[];
}
/**
 * @generated from protobuf message c1.api.user.v1.UserAttributeManagementServiceCreateResponse
 */
export interface UserAttributeManagementServiceCreateResponse {
    /**
     * @generated from protobuf field: c1.api.user.v1.UserAttributeMappingView attribute = 1;
     */
    attribute?: UserAttributeMappingView;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.user.v1.UserAttributeManagementServiceUpdateDisplayNameRequest
 */
export interface UserAttributeManagementServiceUpdateDisplayNameRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string display_name = 2;
     */
    displayName: string;
}
/**
 * @generated from protobuf message c1.api.user.v1.UserAttributeManagementServiceUpdateDisplayNameResponse
 */
export interface UserAttributeManagementServiceUpdateDisplayNameResponse {
    /**
     * @generated from protobuf field: c1.api.user.v1.UserAttributeMapping attribute = 1;
     */
    attribute?: UserAttributeMapping;
}
/**
 * @generated from protobuf message c1.api.user.v1.UserAttributeManagementServiceDeleteRequest
 */
export interface UserAttributeManagementServiceDeleteRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.user.v1.UserAttributeManagementServiceDeleteResponse
 */
export interface UserAttributeManagementServiceDeleteResponse {
}
/**
 * @generated from protobuf message c1.api.user.v1.UserAttributeManagementServiceUpdateRequest
 */
export interface UserAttributeManagementServiceUpdateRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: c1.api.user.v1.UserAttributeType attribute_type = 2;
     */
    attributeType?: UserAttributeType;
    /**
     * @generated from protobuf field: c1.api.user.v1.UserAttributeMapConfigExpandMask expand_mask = 3;
     */
    expandMask?: UserAttributeMapConfigExpandMask;
    /**
     * @generated from protobuf field: repeated c1.api.user.v1.UserAttributeMappingFallback fallbacks = 4;
     */
    fallbacks: UserAttributeMappingFallback[];
    /**
     * @generated from protobuf field: repeated string profile_type_ids = 5;
     */
    profileTypeIds: string[];
}
/**
 * @generated from protobuf message c1.api.user.v1.UserAttributeManagementServiceUpdateResponse
 */
export interface UserAttributeManagementServiceUpdateResponse {
    /**
     * @generated from protobuf field: c1.api.user.v1.UserAttributeMappingView attribute = 1;
     */
    attribute?: UserAttributeMappingView;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.user.v1.UserAttributeSearchServiceSearchRequest
 */
export interface UserAttributeSearchServiceSearchRequest {
    /**
     * @generated from protobuf field: string query = 1;
     */
    query: string;
    /**
     * @generated from protobuf field: int32 page_size = 2;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3;
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.user.v1.UserAttributeSearchServiceSearchResponse
 */
export interface UserAttributeSearchServiceSearchResponse {
    /**
     * @generated from protobuf field: repeated c1.api.user.v1.UserAttributeMapping list = 1;
     */
    list: UserAttributeMapping[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.user.v1.UserAttributeSearchServiceSearchMappingsRequest
 */
export interface UserAttributeSearchServiceSearchMappingsRequest {
    /**
     * @generated from protobuf field: string query = 1;
     */
    query: string;
    /**
     * @generated from protobuf field: repeated string display_names = 2;
     */
    displayNames: string[];
    /**
     * @generated from protobuf field: repeated string app_user_profile_attribute_keys = 3;
     */
    appUserProfileAttributeKeys: string[];
    /**
     * @generated from protobuf field: repeated string app_ids = 4;
     */
    appIds: string[];
    /**
     * @generated from protobuf field: int32 page_size = 5;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 6;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.user.v1.UserAttributeMapConfigExpandMask expand_mask = 7;
     */
    expandMask?: UserAttributeMapConfigExpandMask;
    /**
     * @generated from protobuf field: repeated c1.api.user.v1.UserAttributeMappingRef refs = 8;
     */
    refs: UserAttributeMappingRef[];
}
/**
 * @generated from protobuf message c1.api.user.v1.UserAttributeSearchServiceSearchMappingsResponse
 */
export interface UserAttributeSearchServiceSearchMappingsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.user.v1.UserAttributeMappingView list = 1;
     */
    list: UserAttributeMappingView[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3;
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.user.v1.UserAttributeSearchServiceSearchTermsRequest
 */
export interface UserAttributeSearchServiceSearchTermsRequest {
    /**
     * @generated from protobuf field: c1.api.user.v1.UserAttributeSearchServiceSearchMappingsRequest search = 1;
     */
    search?: UserAttributeSearchServiceSearchMappingsRequest;
    /**
     * @generated from protobuf field: c1.api.user.v1.UserAttributeSearchServiceSearchTermsRequest.TermType term = 2;
     */
    term: UserAttributeSearchServiceSearchTermsRequest_TermType;
    /**
     * @generated from protobuf field: string query = 3;
     */
    query: string;
    /**
     * @generated from protobuf field: bool include_count = 4;
     */
    includeCount: boolean;
}
/**
 * @generated from protobuf enum c1.api.user.v1.UserAttributeSearchServiceSearchTermsRequest.TermType
 */
export enum UserAttributeSearchServiceSearchTermsRequest_TermType {
    /**
     * @generated from protobuf enum value: UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: DISPLAY_NAMES = 1;
     */
    DISPLAY_NAMES = 1,
    /**
     * @generated from protobuf enum value: APP_IDS = 2;
     */
    APP_IDS = 2
}
/**
 * @generated from protobuf message c1.api.user.v1.UserAttributeSearchServiceSearchTermsResponse
 */
export interface UserAttributeSearchServiceSearchTermsResponse {
    /**
     * @generated from protobuf field: c1.api.search.v1.Facets facets = 1;
     */
    facets?: Facets;
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.user.v1.UserAttributeManagementServicePreviewRequest
 */
export interface UserAttributeManagementServicePreviewRequest {
    /**
     * @generated from protobuf field: c1.api.user.v1.UserAttributeMapping mapping = 1;
     */
    mapping?: UserAttributeMapping;
    /**
     * @generated from protobuf field: repeated string user_ids = 2;
     */
    userIds: string[];
    /**
     * @generated from protobuf field: repeated string profile_type_ids = 3;
     */
    profileTypeIds: string[];
}
/**
 * @generated from protobuf message c1.api.user.v1.UserAttributeMappingPreviewResult
 */
export interface UserAttributeMappingPreviewResult {
    /**
     * @generated from protobuf field: string user_id = 1;
     */
    userId: string;
    /**
     * @generated from protobuf field: string username = 2;
     */
    username: string;
    /**
     * @generated from protobuf field: string display_name = 3;
     */
    displayName: string;
    /**
     * @deprecated
     * @generated from protobuf field: string calculated_value = 4 [deprecated = true];
     */
    calculatedValue: string;
    /**
     * @generated from protobuf oneof: value
     */
    value: {
        oneofKind: "stringValue";
        /**
         * @generated from protobuf field: string string_value = 100;
         */
        stringValue: string;
    } | {
        oneofKind: "stringValues";
        /**
         * @generated from protobuf field: c1.api.user.v1.UserAttributeMappingPreviewResult.StringValues string_values = 101;
         */
        stringValues: UserAttributeMappingPreviewResult_StringValues;
    } | {
        oneofKind: "users";
        /**
         * @generated from protobuf field: c1.api.user.v1.UserAttributeMappingPreviewResult.Users users = 102;
         */
        users: UserAttributeMappingPreviewResult_Users;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf field: string error_message = 5;
     */
    errorMessage: string;
}
/**
 * @generated from protobuf message c1.api.user.v1.UserAttributeMappingPreviewResult.StringValues
 */
export interface UserAttributeMappingPreviewResult_StringValues {
    /**
     * @generated from protobuf field: repeated string values = 1;
     */
    values: string[];
}
/**
 * @generated from protobuf message c1.api.user.v1.UserAttributeMappingPreviewResult.Users
 */
export interface UserAttributeMappingPreviewResult_Users {
    /**
     * @generated from protobuf field: repeated c1.api.user.v1.UserAttributeMappingPreviewResult.Users.User values = 1;
     */
    values: UserAttributeMappingPreviewResult_Users_User[];
}
/**
 * @generated from protobuf message c1.api.user.v1.UserAttributeMappingPreviewResult.Users.User
 */
export interface UserAttributeMappingPreviewResult_Users_User {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string username = 2;
     */
    username: string;
    /**
     * @generated from protobuf field: string display_name = 3;
     */
    displayName: string;
}
/**
 * @generated from protobuf message c1.api.user.v1.UserAttributeManagementServicePreviewResponse
 */
export interface UserAttributeManagementServicePreviewResponse {
    /**
     * @deprecated
     * @generated from protobuf field: repeated string preview = 1 [deprecated = true];
     */
    preview: string[];
    /**
     * @generated from protobuf field: repeated c1.api.user.v1.UserAttributeMappingPreviewResult results = 2;
     */
    results: UserAttributeMappingPreviewResult[];
}
/**
 * @generated from protobuf message c1.api.user.v1.UserAttributeSearchServiceSearchErrorLogsRequest
 */
export interface UserAttributeSearchServiceSearchErrorLogsRequest {
    /**
     * @generated from protobuf field: string user_attribute_mapping_id = 1;
     */
    userAttributeMappingId: string;
    /**
     * @generated from protobuf field: string query = 2;
     */
    query: string;
    /**
     * @generated from protobuf field: repeated string user_ids = 3;
     */
    userIds: string[];
    /**
     * @generated from protobuf field: int32 page_size = 4;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 5;
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.user.v1.UserAttributeSearchServiceSearchErrorLogsResponse
 */
export interface UserAttributeSearchServiceSearchErrorLogsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.user.v1.UserAttributeMappingErrorLog list = 1;
     */
    list: UserAttributeMappingErrorLog[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributeManagementServiceListAttributeTypesRequest$Type extends MessageType<UserAttributeManagementServiceListAttributeTypesRequest> {
    constructor() {
        super("c1.api.user.v1.UserAttributeManagementServiceListAttributeTypesRequest", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserAttributeManagementServiceListAttributeTypesRequest
 */
export const UserAttributeManagementServiceListAttributeTypesRequest = new UserAttributeManagementServiceListAttributeTypesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributeTypeConfigApp$Type extends MessageType<UserAttributeTypeConfigApp> {
    constructor() {
        super("c1.api.user.v1.UserAttributeTypeConfigApp", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserAttributeTypeConfigApp
 */
export const UserAttributeTypeConfigApp = new UserAttributeTypeConfigApp$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributeTypeConfigAppUserProfile$Type extends MessageType<UserAttributeTypeConfigAppUserProfile> {
    constructor() {
        super("c1.api.user.v1.UserAttributeTypeConfigAppUserProfile", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "app_user_profile_attribute_key", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserAttributeTypeConfigAppUserProfile
 */
export const UserAttributeTypeConfigAppUserProfile = new UserAttributeTypeConfigAppUserProfile$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributeTypeConfigCustomAppUserProfile$Type extends MessageType<UserAttributeTypeConfigCustomAppUserProfile> {
    constructor() {
        super("c1.api.user.v1.UserAttributeTypeConfigCustomAppUserProfile", [
            { no: 1, name: "user_profile_attribute_key", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "app_user_profile_attribute_key", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserAttributeTypeConfigCustomAppUserProfile
 */
export const UserAttributeTypeConfigCustomAppUserProfile = new UserAttributeTypeConfigCustomAppUserProfile$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributeTypeConfigCelExpression$Type extends MessageType<UserAttributeTypeConfigCelExpression> {
    constructor() {
        super("c1.api.user.v1.UserAttributeTypeConfigCelExpression", [
            { no: 1, name: "user_profile_attribute_key", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "cel_expression", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserAttributeTypeConfigCelExpression
 */
export const UserAttributeTypeConfigCelExpression = new UserAttributeTypeConfigCelExpression$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributeType$Type extends MessageType<UserAttributeType> {
    constructor() {
        super("c1.api.user.v1.UserAttributeType", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 100, name: "app", kind: "message", oneof: "config", T: () => UserAttributeTypeConfigApp },
            { no: 101, name: "app_user_profile", kind: "message", oneof: "config", T: () => UserAttributeTypeConfigAppUserProfile },
            { no: 102, name: "custom_app_user_profile", kind: "message", oneof: "config", T: () => UserAttributeTypeConfigCustomAppUserProfile },
            { no: 103, name: "cel_expression", kind: "message", oneof: "config", T: () => UserAttributeTypeConfigCelExpression }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserAttributeType
 */
export const UserAttributeType = new UserAttributeType$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributeMappingFallback$Type extends MessageType<UserAttributeMappingFallback> {
    constructor() {
        super("c1.api.user.v1.UserAttributeMappingFallback", [
            { no: 100, name: "app", kind: "message", oneof: "fallback", T: () => UserAttributeTypeConfigApp },
            { no: 101, name: "app_user_profile", kind: "message", oneof: "fallback", T: () => UserAttributeTypeConfigAppUserProfile },
            { no: 102, name: "cel_expression", kind: "message", oneof: "fallback", T: () => UserAttributeTypeConfigCelExpression }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserAttributeMappingFallback
 */
export const UserAttributeMappingFallback = new UserAttributeMappingFallback$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributeManagementServiceListAttributeTypesResponse$Type extends MessageType<UserAttributeManagementServiceListAttributeTypesResponse> {
    constructor() {
        super("c1.api.user.v1.UserAttributeManagementServiceListAttributeTypesResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserAttributeType }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserAttributeManagementServiceListAttributeTypesResponse
 */
export const UserAttributeManagementServiceListAttributeTypesResponse = new UserAttributeManagementServiceListAttributeTypesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributeManagementServiceListRequest$Type extends MessageType<UserAttributeManagementServiceListRequest> {
    constructor() {
        super("c1.api.user.v1.UserAttributeManagementServiceListRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "expand_mask", kind: "message", T: () => UserAttributeMapConfigExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserAttributeManagementServiceListRequest
 */
export const UserAttributeManagementServiceListRequest = new UserAttributeManagementServiceListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributeManagementServiceListResponse$Type extends MessageType<UserAttributeManagementServiceListResponse> {
    constructor() {
        super("c1.api.user.v1.UserAttributeManagementServiceListResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserAttributeMappingView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserAttributeManagementServiceListResponse
 */
export const UserAttributeManagementServiceListResponse = new UserAttributeManagementServiceListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributeMapping$Type extends MessageType<UserAttributeMapping> {
    constructor() {
        super("c1.api.user.v1.UserAttributeMapping", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "app_user_profile_attribute_key", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 6, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 7, name: "count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "attribute_type", kind: "message", T: () => UserAttributeType },
            { no: 9, name: "priority", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 10, name: "fallbacks", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserAttributeMappingFallback },
            { no: 11, name: "evaluation_error_count", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserAttributeMapping
 */
export const UserAttributeMapping = new UserAttributeMapping$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributeMappingView$Type extends MessageType<UserAttributeMappingView> {
    constructor() {
        super("c1.api.user.v1.UserAttributeMappingView", [
            { no: 1, name: "user_attribute_mapping", kind: "message", T: () => UserAttributeMapping },
            { no: 2, name: "app_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "fallbacks_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserAttributeMappingView
 */
export const UserAttributeMappingView = new UserAttributeMappingView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributeMappingRef$Type extends MessageType<UserAttributeMappingRef> {
    constructor() {
        super("c1.api.user.v1.UserAttributeMappingRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserAttributeMappingRef
 */
export const UserAttributeMappingRef = new UserAttributeMappingRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributeMappingErrorLog$Type extends MessageType<UserAttributeMappingErrorLog> {
    constructor() {
        super("c1.api.user.v1.UserAttributeMappingErrorLog", [
            { no: 1, name: "user_attribute_mapping_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "error", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserAttributeMappingErrorLog
 */
export const UserAttributeMappingErrorLog = new UserAttributeMappingErrorLog$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributeManagementServiceGetRequest$Type extends MessageType<UserAttributeManagementServiceGetRequest> {
    constructor() {
        super("c1.api.user.v1.UserAttributeManagementServiceGetRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "expand_mask", kind: "message", T: () => UserAttributeMapConfigExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserAttributeManagementServiceGetRequest
 */
export const UserAttributeManagementServiceGetRequest = new UserAttributeManagementServiceGetRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributeManagementServiceGetResponse$Type extends MessageType<UserAttributeManagementServiceGetResponse> {
    constructor() {
        super("c1.api.user.v1.UserAttributeManagementServiceGetResponse", [
            { no: 1, name: "attribute", kind: "message", T: () => UserAttributeMappingView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserAttributeManagementServiceGetResponse
 */
export const UserAttributeManagementServiceGetResponse = new UserAttributeManagementServiceGetResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributeMapConfigExpandMask$Type extends MessageType<UserAttributeMapConfigExpandMask> {
    constructor() {
        super("c1.api.user.v1.UserAttributeMapConfigExpandMask", [
            { no: 1, name: "paths", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { in: ["*", "app_id", "fallbacks"] } }, ignoreEmpty: true } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserAttributeMapConfigExpandMask
 */
export const UserAttributeMapConfigExpandMask = new UserAttributeMapConfigExpandMask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributeManagementServiceCreateRequest$Type extends MessageType<UserAttributeManagementServiceCreateRequest> {
    constructor() {
        super("c1.api.user.v1.UserAttributeManagementServiceCreateRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } },
            { no: 2, name: "app_user_profile_attribute_key", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { maxBytes: "1024" } } } },
            { no: 3, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { maxBytes: "1024" } } } },
            { no: 5, name: "attribute_type", kind: "message", T: () => UserAttributeType },
            { no: 4, name: "expand_mask", kind: "message", T: () => UserAttributeMapConfigExpandMask },
            { no: 6, name: "fallbacks", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserAttributeMappingFallback },
            { no: 7, name: "profile_type_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } }, ignoreEmpty: true } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserAttributeManagementServiceCreateRequest
 */
export const UserAttributeManagementServiceCreateRequest = new UserAttributeManagementServiceCreateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributeManagementServiceCreateResponse$Type extends MessageType<UserAttributeManagementServiceCreateResponse> {
    constructor() {
        super("c1.api.user.v1.UserAttributeManagementServiceCreateResponse", [
            { no: 1, name: "attribute", kind: "message", T: () => UserAttributeMappingView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserAttributeManagementServiceCreateResponse
 */
export const UserAttributeManagementServiceCreateResponse = new UserAttributeManagementServiceCreateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributeManagementServiceUpdateDisplayNameRequest$Type extends MessageType<UserAttributeManagementServiceUpdateDisplayNameRequest> {
    constructor() {
        super("c1.api.user.v1.UserAttributeManagementServiceUpdateDisplayNameRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { maxBytes: "1024" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserAttributeManagementServiceUpdateDisplayNameRequest
 */
export const UserAttributeManagementServiceUpdateDisplayNameRequest = new UserAttributeManagementServiceUpdateDisplayNameRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributeManagementServiceUpdateDisplayNameResponse$Type extends MessageType<UserAttributeManagementServiceUpdateDisplayNameResponse> {
    constructor() {
        super("c1.api.user.v1.UserAttributeManagementServiceUpdateDisplayNameResponse", [
            { no: 1, name: "attribute", kind: "message", T: () => UserAttributeMapping }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserAttributeManagementServiceUpdateDisplayNameResponse
 */
export const UserAttributeManagementServiceUpdateDisplayNameResponse = new UserAttributeManagementServiceUpdateDisplayNameResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributeManagementServiceDeleteRequest$Type extends MessageType<UserAttributeManagementServiceDeleteRequest> {
    constructor() {
        super("c1.api.user.v1.UserAttributeManagementServiceDeleteRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserAttributeManagementServiceDeleteRequest
 */
export const UserAttributeManagementServiceDeleteRequest = new UserAttributeManagementServiceDeleteRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributeManagementServiceDeleteResponse$Type extends MessageType<UserAttributeManagementServiceDeleteResponse> {
    constructor() {
        super("c1.api.user.v1.UserAttributeManagementServiceDeleteResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserAttributeManagementServiceDeleteResponse
 */
export const UserAttributeManagementServiceDeleteResponse = new UserAttributeManagementServiceDeleteResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributeManagementServiceUpdateRequest$Type extends MessageType<UserAttributeManagementServiceUpdateRequest> {
    constructor() {
        super("c1.api.user.v1.UserAttributeManagementServiceUpdateRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "attribute_type", kind: "message", T: () => UserAttributeType },
            { no: 3, name: "expand_mask", kind: "message", T: () => UserAttributeMapConfigExpandMask },
            { no: 4, name: "fallbacks", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserAttributeMappingFallback },
            { no: 5, name: "profile_type_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserAttributeManagementServiceUpdateRequest
 */
export const UserAttributeManagementServiceUpdateRequest = new UserAttributeManagementServiceUpdateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributeManagementServiceUpdateResponse$Type extends MessageType<UserAttributeManagementServiceUpdateResponse> {
    constructor() {
        super("c1.api.user.v1.UserAttributeManagementServiceUpdateResponse", [
            { no: 1, name: "attribute", kind: "message", T: () => UserAttributeMappingView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserAttributeManagementServiceUpdateResponse
 */
export const UserAttributeManagementServiceUpdateResponse = new UserAttributeManagementServiceUpdateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributeSearchServiceSearchRequest$Type extends MessageType<UserAttributeSearchServiceSearchRequest> {
    constructor() {
        super("c1.api.user.v1.UserAttributeSearchServiceSearchRequest", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserAttributeSearchServiceSearchRequest
 */
export const UserAttributeSearchServiceSearchRequest = new UserAttributeSearchServiceSearchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributeSearchServiceSearchResponse$Type extends MessageType<UserAttributeSearchServiceSearchResponse> {
    constructor() {
        super("c1.api.user.v1.UserAttributeSearchServiceSearchResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserAttributeMapping },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserAttributeSearchServiceSearchResponse
 */
export const UserAttributeSearchServiceSearchResponse = new UserAttributeSearchServiceSearchResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributeSearchServiceSearchMappingsRequest$Type extends MessageType<UserAttributeSearchServiceSearchMappingsRequest> {
    constructor() {
        super("c1.api.user.v1.UserAttributeSearchServiceSearchMappingsRequest", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "display_names", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "app_user_profile_attribute_keys", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "app_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 6, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 7, name: "expand_mask", kind: "message", T: () => UserAttributeMapConfigExpandMask },
            { no: 8, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserAttributeMappingRef }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserAttributeSearchServiceSearchMappingsRequest
 */
export const UserAttributeSearchServiceSearchMappingsRequest = new UserAttributeSearchServiceSearchMappingsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributeSearchServiceSearchMappingsResponse$Type extends MessageType<UserAttributeSearchServiceSearchMappingsResponse> {
    constructor() {
        super("c1.api.user.v1.UserAttributeSearchServiceSearchMappingsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserAttributeMappingView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserAttributeSearchServiceSearchMappingsResponse
 */
export const UserAttributeSearchServiceSearchMappingsResponse = new UserAttributeSearchServiceSearchMappingsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributeSearchServiceSearchTermsRequest$Type extends MessageType<UserAttributeSearchServiceSearchTermsRequest> {
    constructor() {
        super("c1.api.user.v1.UserAttributeSearchServiceSearchTermsRequest", [
            { no: 1, name: "search", kind: "message", T: () => UserAttributeSearchServiceSearchMappingsRequest },
            { no: 2, name: "term", kind: "enum", T: () => ["c1.api.user.v1.UserAttributeSearchServiceSearchTermsRequest.TermType", UserAttributeSearchServiceSearchTermsRequest_TermType] },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "include_count", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserAttributeSearchServiceSearchTermsRequest
 */
export const UserAttributeSearchServiceSearchTermsRequest = new UserAttributeSearchServiceSearchTermsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributeSearchServiceSearchTermsResponse$Type extends MessageType<UserAttributeSearchServiceSearchTermsResponse> {
    constructor() {
        super("c1.api.user.v1.UserAttributeSearchServiceSearchTermsResponse", [
            { no: 1, name: "facets", kind: "message", T: () => Facets },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserAttributeSearchServiceSearchTermsResponse
 */
export const UserAttributeSearchServiceSearchTermsResponse = new UserAttributeSearchServiceSearchTermsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributeManagementServicePreviewRequest$Type extends MessageType<UserAttributeManagementServicePreviewRequest> {
    constructor() {
        super("c1.api.user.v1.UserAttributeManagementServicePreviewRequest", [
            { no: 1, name: "mapping", kind: "message", T: () => UserAttributeMapping },
            { no: 2, name: "user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { maxItems: "20", unique: true, items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } }, ignoreEmpty: true } } } },
            { no: 3, name: "profile_type_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } }, ignoreEmpty: true } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserAttributeManagementServicePreviewRequest
 */
export const UserAttributeManagementServicePreviewRequest = new UserAttributeManagementServicePreviewRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributeMappingPreviewResult$Type extends MessageType<UserAttributeMappingPreviewResult> {
    constructor() {
        super("c1.api.user.v1.UserAttributeMappingPreviewResult", [
            { no: 1, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "username", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "calculated_value", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 100, name: "string_value", kind: "scalar", oneof: "value", T: 9 /*ScalarType.STRING*/ },
            { no: 101, name: "string_values", kind: "message", oneof: "value", T: () => UserAttributeMappingPreviewResult_StringValues },
            { no: 102, name: "users", kind: "message", oneof: "value", T: () => UserAttributeMappingPreviewResult_Users },
            { no: 5, name: "error_message", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserAttributeMappingPreviewResult
 */
export const UserAttributeMappingPreviewResult = new UserAttributeMappingPreviewResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributeMappingPreviewResult_StringValues$Type extends MessageType<UserAttributeMappingPreviewResult_StringValues> {
    constructor() {
        super("c1.api.user.v1.UserAttributeMappingPreviewResult.StringValues", [
            { no: 1, name: "values", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserAttributeMappingPreviewResult.StringValues
 */
export const UserAttributeMappingPreviewResult_StringValues = new UserAttributeMappingPreviewResult_StringValues$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributeMappingPreviewResult_Users$Type extends MessageType<UserAttributeMappingPreviewResult_Users> {
    constructor() {
        super("c1.api.user.v1.UserAttributeMappingPreviewResult.Users", [
            { no: 1, name: "values", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserAttributeMappingPreviewResult_Users_User }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserAttributeMappingPreviewResult.Users
 */
export const UserAttributeMappingPreviewResult_Users = new UserAttributeMappingPreviewResult_Users$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributeMappingPreviewResult_Users_User$Type extends MessageType<UserAttributeMappingPreviewResult_Users_User> {
    constructor() {
        super("c1.api.user.v1.UserAttributeMappingPreviewResult.Users.User", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "username", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserAttributeMappingPreviewResult.Users.User
 */
export const UserAttributeMappingPreviewResult_Users_User = new UserAttributeMappingPreviewResult_Users_User$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributeManagementServicePreviewResponse$Type extends MessageType<UserAttributeManagementServicePreviewResponse> {
    constructor() {
        super("c1.api.user.v1.UserAttributeManagementServicePreviewResponse", [
            { no: 1, name: "preview", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserAttributeMappingPreviewResult }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserAttributeManagementServicePreviewResponse
 */
export const UserAttributeManagementServicePreviewResponse = new UserAttributeManagementServicePreviewResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributeSearchServiceSearchErrorLogsRequest$Type extends MessageType<UserAttributeSearchServiceSearchErrorLogsRequest> {
    constructor() {
        super("c1.api.user.v1.UserAttributeSearchServiceSearchErrorLogsRequest", [
            { no: 1, name: "user_attribute_mapping_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } }, ignoreEmpty: true } } } },
            { no: 4, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 5, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserAttributeSearchServiceSearchErrorLogsRequest
 */
export const UserAttributeSearchServiceSearchErrorLogsRequest = new UserAttributeSearchServiceSearchErrorLogsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributeSearchServiceSearchErrorLogsResponse$Type extends MessageType<UserAttributeSearchServiceSearchErrorLogsResponse> {
    constructor() {
        super("c1.api.user.v1.UserAttributeSearchServiceSearchErrorLogsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserAttributeMappingErrorLog },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserAttributeSearchServiceSearchErrorLogsResponse
 */
export const UserAttributeSearchServiceSearchErrorLogsResponse = new UserAttributeSearchServiceSearchErrorLogsResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.user.v1.UserAttributeManagementService
 */
export const UserAttributeManagementService = new ServiceType("c1.api.user.v1.UserAttributeManagementService", [
    { name: "List", options: { "authz.method": { role: "VIEWER" } }, I: UserAttributeManagementServiceListRequest, O: UserAttributeManagementServiceListResponse },
    { name: "Get", options: { "authz.method": { role: "VIEWER" } }, I: UserAttributeManagementServiceGetRequest, O: UserAttributeManagementServiceGetResponse },
    { name: "Create", options: { "authz.method": { role: "EDITOR" } }, I: UserAttributeManagementServiceCreateRequest, O: UserAttributeManagementServiceCreateResponse },
    { name: "Delete", options: { "authz.method": { role: "EDITOR" } }, I: UserAttributeManagementServiceDeleteRequest, O: UserAttributeManagementServiceDeleteResponse },
    { name: "ListAttributeTypes", options: { "authz.method": { role: "VIEWER" } }, I: UserAttributeManagementServiceListAttributeTypesRequest, O: UserAttributeManagementServiceListAttributeTypesResponse },
    { name: "Preview", options: { "authz.method": { role: "VIEWER" } }, I: UserAttributeManagementServicePreviewRequest, O: UserAttributeManagementServicePreviewResponse },
    { name: "Update", options: { "authz.method": { role: "EDITOR" } }, I: UserAttributeManagementServiceUpdateRequest, O: UserAttributeManagementServiceUpdateResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.user.v1.UserAttributeSearchService
 */
export const UserAttributeSearchService = new ServiceType("c1.api.user.v1.UserAttributeSearchService", [
    { name: "Search", options: { "authz.method": { role: "VIEWER" } }, I: UserAttributeSearchServiceSearchRequest, O: UserAttributeSearchServiceSearchResponse },
    { name: "SearchMappings", options: { "authz.method": { role: "VIEWER" } }, I: UserAttributeSearchServiceSearchMappingsRequest, O: UserAttributeSearchServiceSearchMappingsResponse },
    { name: "GetSearchTerms", options: { "authz.method": { role: "VIEWER" } }, I: UserAttributeSearchServiceSearchTermsRequest, O: UserAttributeSearchServiceSearchTermsResponse },
    { name: "SearchErrorLogs", options: { "authz.method": { role: "VIEWER" } }, I: UserAttributeSearchServiceSearchErrorLogsRequest, O: UserAttributeSearchServiceSearchErrorLogsResponse }
]);
